var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomMessageChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_643_2948)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 27.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9222 42.9943C30.5279 42.9943 28.1335 43.0009 25.7392 42.9878C24.4444 42.9812 23.3839 42.1158 23.0781 40.8504C23.0195 40.6143 23 40.3652 23 40.1226C23 35.3692 23 30.6158 23 25.8623C23 24.1773 24.1972 22.9709 25.8758 22.9709C28.5174 22.9709 31.1525 22.9709 33.7941 22.9709C34.3016 22.9709 34.6074 23.325 34.4707 23.7381C34.3926 23.9806 34.2235 24.1183 33.9697 24.138C33.8721 24.1446 33.7745 24.1446 33.6769 24.1446C31.0939 24.1446 28.5109 24.1446 25.9279 24.1446C24.8478 24.1446 24.2167 24.7805 24.2102 25.8623C24.2102 30.583 24.2102 35.3036 24.2102 40.0243C24.2102 41.1061 24.8478 41.742 25.9279 41.742C30.6059 41.742 35.284 41.742 39.9621 41.742C41.0356 41.742 41.6668 41.0995 41.6668 40.0111C41.6668 37.4148 41.6668 34.825 41.6668 32.2286C41.6668 32.1565 41.6668 32.0844 41.6668 32.0057C41.6863 31.6582 41.9335 31.4025 42.2523 31.4025C42.5777 31.4025 42.8314 31.6582 42.8379 32.0254C42.8379 34.7922 42.8509 37.559 42.8314 40.3193C42.8184 41.742 41.6277 42.955 40.2158 42.9681C37.8801 42.9943 35.5378 42.9812 33.202 42.9812C33.1044 42.9943 33.0133 42.9943 32.9222 42.9943Z",
    fill: "#F43333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9969 23.2003C45.9904 23.692 45.7887 24.0789 45.4569 24.4132C43.8693 26.0064 42.2883 27.6062 40.7072 29.206C39.4255 30.5042 38.1372 31.7958 36.8555 33.1005C36.5041 33.4611 36.1007 33.7103 35.6192 33.8479C34.9881 34.0315 34.3635 34.2217 33.7324 34.4184C33.0948 34.6151 32.5417 34.4708 32.0798 34.0053C31.6178 33.5398 31.5137 32.9759 31.7024 32.3531C31.9041 31.6974 32.0993 31.0418 32.288 30.3796C32.4051 29.9731 32.6133 29.619 32.9126 29.3174C35.8144 26.3933 38.7163 23.4757 41.6181 20.558C42.3598 19.8106 43.3618 19.8172 44.11 20.5646C44.559 21.0104 45.0079 21.4694 45.4504 21.9152C45.8082 22.2758 45.9904 22.7086 45.9969 23.2003ZM39.985 23.8297C39.959 23.8494 39.933 23.8756 39.9004 23.9018C37.8509 25.9737 35.7949 28.0455 33.7519 30.1239C33.6023 30.2747 33.4917 30.4845 33.4201 30.6812C33.2054 31.3303 33.0232 31.9925 32.8215 32.6481C32.7629 32.8448 32.7629 33.0153 32.9126 33.1726C33.0687 33.3365 33.2509 33.33 33.4526 33.271C34.0382 33.0874 34.6303 32.9038 35.2224 32.7334C35.5542 32.6416 35.8274 32.4777 36.0682 32.2351C38.0461 30.2288 40.0371 28.2291 42.0215 26.2294C42.0866 26.1638 42.1712 26.1245 42.2297 26.0851C41.4555 25.3115 40.7267 24.5771 39.985 23.8297ZM40.8504 22.9184C41.6116 23.6855 42.3338 24.4132 43.0495 25.1279C43.596 24.5903 44.1751 24.0461 44.7282 23.4757C44.9103 23.2921 44.8518 23.0429 44.6956 22.8725C44.2011 22.3414 43.6936 21.83 43.1731 21.3251C42.9584 21.1153 42.6721 21.1153 42.4965 21.2924C41.9434 21.83 41.3969 22.3742 40.8504 22.9184Z",
    fill: "#F43333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5884 39.8535C29.5019 39.8535 28.4153 39.8535 27.3287 39.8535C27.0815 39.8535 26.8863 39.7552 26.7692 39.5322C26.6651 39.3355 26.6781 39.1388 26.8017 38.9487C26.9319 38.7455 27.1336 38.6733 27.3678 38.6733C27.9338 38.6733 28.5064 38.6733 29.0725 38.6733C30.6145 38.6733 32.1565 38.6733 33.6985 38.6733C33.7701 38.6733 33.8416 38.6733 33.9197 38.6733C34.2645 38.6996 34.5118 38.9487 34.5053 39.27C34.5053 39.5978 34.258 39.8469 33.9067 39.8469C32.8006 39.8535 31.6945 39.8535 30.5884 39.8535Z",
    fill: "#F43333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6434 37.1063C28.214 37.1063 27.7846 37.1128 27.3552 37.1063C26.9648 37.0997 26.7111 36.8702 26.7111 36.5293C26.7045 36.1818 26.9713 35.9327 27.3682 35.9327C28.227 35.9261 29.0859 35.9261 29.9447 35.9327C30.3416 35.9327 30.6084 36.1818 30.6019 36.5293C30.5954 36.8702 30.3481 37.1063 29.9577 37.1063C29.5153 37.1063 29.0794 37.1063 28.6434 37.1063Z",
    fill: "#F43333"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_643_2948",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_643_2948"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_643_2948"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_643_2948",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomMessageChip);
export default __webpack_public_path__ + "static/media/custom-message-chip.60cb670ab692549a16bb0230d37ef4bc.svg";
export { ForwardRef as ReactComponent };